import type { FC } from 'react';
import React from 'react';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { ASSET_NAME_BOND } from '@alfa-bank/site-invest-emitents-common/src/constants';

import type { IHintDynamicsContentProps } from './models';
import { BOND_DYNAMICS_HINT, COMMON_DYNAMICS_HINT } from './constants';

export const HintDynamicsContentDesktop: FC<IHintDynamicsContentProps> = ({ assetTypeCode }) => (
    <Text styler={{ margin: 0 }} view="primary-small">
        {assetTypeCode === ASSET_NAME_BOND ? BOND_DYNAMICS_HINT : COMMON_DYNAMICS_HINT}
    </Text>
);
